import React, { FC } from 'react';
import { X } from 'react-bootstrap-icons';
import Style from '../../styles/components/alers.module.css';


type TypeCloseBtn = {
    onClick: () => void
}

const CloseBtn: FC<TypeCloseBtn> = ({ onClick }) => {

    return (
       <button className={Style.btnCloseAlet} onClick={onClick}>
            <X className={Style.btnCloseAletIcon} />
       </button>
    );
}

export default CloseBtn;